export default {"src":"/_next/static/media/center-align.70eed6c0.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};